import React from 'react';
import { Helmet } from 'react-helmet';

import { APP_DESCRIPTION, APP_TITLE } from '../constants';

export const HeadComponent = ({ title, description }) => (
    <Helmet>
        <title>{`${APP_TITLE}${title}`}</title>
        <meta name="description" content={description ? description : APP_DESCRIPTION} />
    </Helmet>
);



// WEBPACK FOOTER //
// ./src/components/HeadComponent.js